export default {"src":"/_next/static/media/money.4ad24288.svg","height":12,"width":13};